/**
 * @module tagging
 */
import { sendCriteoEvent } from '@ma-js-common/criteo-helpers';
import { v4 as uuidv4 } from 'uuid';

import Ga from './ga';
import MaEvent from './ma-event';
import Wa from './wa';

/**
 *
 * @param {jQuery} $form
 * @param {Object} uaEvent GA event
 * @param {String} uaEvent.category GA event cetegory
 * @param {String} uaEvent.actionPrefix GA event action prefix, will be suffixed with `landed` `started` `submit_attempt` `submit_success`
 * @param {String} uaEvent.label GA event label
 * @param {Object} waSuccessEvent WA event
 * @param {String} waSuccessEvent.key WA event key
 * @param {String} waSuccessEvent.name WA event name
 * @param {String} waSuccessEvent.data WA event data
 * @param {Boolean} waLandedEvent Should trigger the landed event ?
 * @param {Function} hitCallbackSuccess Add hitCallback function for success event (will be wrapped in a 2sec timeout for ensuring it's execution if Google goes down)
 * @param {Object} criteoData Data used to send criteoEvents
 */
export function bindForm(
    $form,
    uaEvent,
    waSuccessEvent,
    waLandedEvent,
    hitCallbackSuccess,
    criteoData,
) {
    if ($form.length > 0) {
        Ga.send({
            hitType: 'event',
            eventCategory: uaEvent.category,
            eventAction: `${uaEvent.actionPrefix}:landed`,
            eventLabel: uaEvent.label,
            nonInteraction: true,
        });

        if (waLandedEvent) {
            let { data } = waLandedEvent;
            data += Wa.computeData(MA.Context.waData);

            Wa.push(waLandedEvent.key, waLandedEvent.name, data);
        }
    }

    $form.one(MaEvent.formStarted, () => {
        Ga.send({
            hitType: 'event',
            eventCategory: uaEvent.category,
            eventAction: `${uaEvent.actionPrefix}:started`,
            eventLabel: uaEvent.label,
        });

        if (criteoData) {
            sendCriteoEvent({
                event: 'viewBasket',
                item: [{ id: criteoData.id, quantity: '1', price: '1' }],
                atype: criteoData.atype,
            });
        }
    });

    $form.one(MaEvent.formSubmitAttempt, () => {
        Ga.send({
            hitType: 'event',
            eventCategory: uaEvent.category,
            eventAction: `${uaEvent.actionPrefix}:submit_attempt`,
            eventLabel: uaEvent.label,
        });
    });

    $form.one(MaEvent.formSubmitSuccess, () => {
        const gaSuccessEvent = {
            hitType: 'event',
            eventCategory: uaEvent.category,
            eventAction: `${uaEvent.actionPrefix}:submit_success`,
            eventLabel: uaEvent.label,
        };

        if (typeof hitCallbackSuccess === 'function') {
            gaSuccessEvent.hitCallback = Ga.functionWithTimeout(hitCallbackSuccess);
        }

        Ga.send(gaSuccessEvent);
        if (waSuccessEvent) {
            let { data } = waSuccessEvent;
            data += Wa.computeData(MA.Context.waData);

            Wa.push(waSuccessEvent.key, waSuccessEvent.name, data);
        }

        if (criteoData) {
            sendCriteoEvent({
                event: 'trackTransaction',
                id: uuidv4(),
                item: [{ id: criteoData.id, quantity: '1', price: '1' }],
                atype: criteoData.atype,
            });
        }
    });

    $form.one(MaEvent.formSubmitError, () => {
        Ga.send({
            hitType: 'event',
            eventCategory: uaEvent.category,
            eventAction: `${uaEvent.actionPrefix}:submit_error`,
            eventLabel: uaEvent.label,
        });
        if (waSuccessEvent) {
            let { data } = waSuccessEvent;
            data += Wa.computeData(MA.Context.waData);

            Wa.push(waSuccessEvent.key, waSuccessEvent.name, data);
        }
    });
}
